import { render, staticRenderFns } from "./ComparisonHoliday.vue?vue&type=template&id=e483c704&scoped=true&"
import script from "./ComparisonHoliday.vue?vue&type=script&lang=js&"
export * from "./ComparisonHoliday.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonHoliday.vue?vue&type=style&index=0&id=e483c704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e483c704",
  null
  
)

export default component.exports